import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  GetBackofficeFlagsActivityResponseDataSchema,
  GetBackofficeFlagsActivitySchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeFlagsActivitySchema>
type Response = DataResponse<z.infer<typeof GetBackofficeFlagsActivityResponseDataSchema>>

export const getBackofficeFlagsActivityQuery = ({ query }: { query: Query }) =>
  queryOptions({
    queryKey: ["backofficeFlagsActivity", query],
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/flags/activity", { params: query })
      return data.data
    },
  })
